import { render } from "./j_email2.vue?vue&type=template&id=3b4d6f61&scoped=true"
import script from "./j_email2.vue?vue&type=script&lang=js"
export * from "./j_email2.vue?vue&type=script&lang=js"

import "./j_email2.vue?vue&type=style&index=0&id=3b4d6f61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4d6f61"]])

export default __exports__